/* eslint-disable */
import React, { useState } from "react";
import CookieSettingsModal from "./CookieSettingsModal";

const styles = {
    overlay: {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        padding: "0 16px 16px",
        pointerEvents: "none",
    },
    banner: {
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
        borderRadius: "16px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)",
        padding: "24px 28px",
        maxWidth: "900px",
        width: "100%",
        pointerEvents: "all",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.1)",
        animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "10px",
    },
    icon: {
        fontSize: "24px",
    },
    title: {
        color: "#ffffff",
        fontSize: "17px",
        fontWeight: "700",
        margin: 0,
        fontFamily: "'Inter', 'Roboto', sans-serif",
        letterSpacing: "-0.3px",
    },
    text: {
        color: "rgba(255,255,255,0.72)",
        fontSize: "13.5px",
        lineHeight: "1.6",
        margin: "0 0 20px 0",
        fontFamily: "'Inter', 'Roboto', sans-serif",
    },
    link: {
        color: "#60a5fa",
        textDecoration: "underline",
        cursor: "pointer",
    },
    actions: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
    },
    btnAccept: {
        background: "linear-gradient(135deg, #22c55e, #16a34a)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        padding: "11px 24px",
        fontSize: "13.5px",
        fontWeight: "700",
        cursor: "pointer",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        transition: "all 0.2s ease",
        boxShadow: "0 4px 12px rgba(34,197,94,0.3)",
        letterSpacing: "0.2px",
    },
    btnSettings: {
        background: "rgba(255,255,255,0.1)",
        color: "#fff",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: "10px",
        padding: "11px 22px",
        fontSize: "13.5px",
        fontWeight: "600",
        cursor: "pointer",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        transition: "all 0.2s ease",
        backdropFilter: "blur(8px)",
    },
    btnReject: {
        background: "transparent",
        color: "rgba(255,255,255,0.45)",
        border: "none",
        padding: "11px 16px",
        fontSize: "12.5px",
        cursor: "pointer",
        fontFamily: "'Inter', 'Roboto', sans-serif",
        textDecoration: "underline",
        transition: "color 0.2s ease",
    },
    keyframes: `
        @keyframes slideUp {
            from { transform: translateY(120%); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
        }
    `,
};

function CookieBanner({ consent, acceptAll, rejectAll, saveConsent }) {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <style>{styles.keyframes}</style>
            <div style={styles.overlay}>
                <div style={styles.banner}>
                    <div style={styles.header}>
                        <span style={styles.icon}>🍪</span>
                        <p style={styles.title}>Îți respectăm confidențialitatea</p>
                    </div>
                    <p style={styles.text}>
                        Folosim cookie-uri pentru a îmbunătăți experiența ta de navigare și a analiza
                        traficul (Google Analytics). Poți accepta toate cookie-urile, le poți
                        personaliza sau refuza pe cele opționale.{" "}
                        <a href="/politica-cookie" style={styles.link}>
                            Politică Cookies &amp; GDPR →
                        </a>
                    </p>
                    <div style={styles.actions}>
                        <button
                            id="cookie-accept-all"
                            style={styles.btnAccept}
                            onClick={() => {
                                acceptAll();
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = "translateY(-1px)";
                                e.target.style.boxShadow = "0 6px 16px rgba(34,197,94,0.4)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "0 4px 12px rgba(34,197,94,0.3)";
                            }}
                        >
                            ✓ Acceptă toate
                        </button>
                        <button
                            id="cookie-settings"
                            style={styles.btnSettings}
                            onClick={() => setModalOpen(true)}
                            onMouseEnter={(e) => {
                                e.target.style.background = "rgba(255,255,255,0.18)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = "rgba(255,255,255,0.1)";
                            }}
                        >
                            ⚙ Personalizează
                        </button>
                        <button
                            id="cookie-reject-all"
                            style={styles.btnReject}
                            onClick={() => {
                                rejectAll();
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.color = "rgba(255,255,255,0.7)";
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.color = "rgba(255,255,255,0.45)";
                            }}
                        >
                            Refuză toate
                        </button>
                    </div>
                </div>
            </div>
            {modalOpen && (
                <CookieSettingsModal
                    consent={consent}
                    onSave={(newConsent) => {
                        saveConsent(newConsent);
                        setModalOpen(false);
                    }}
                    onClose={() => setModalOpen(false)}
                />
            )}
        </>
    );
}

export default CookieBanner;
